// FIRST, before any module that might fetch on import. candleCache kicks off a preload
// from a setTimeout as soon as it is imported, so installing the interceptor any later
// means those requests go out unauthenticated and 401 — a blank chart on every load.
import { installAuthFetch } from './utils/authFetch';
installAuthFetch();

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import App from './App';
import './index.css';

// One-time symbol migration: V25_1S was a duplicate alias of 1HZ25V (same
// instrument, thinner history) — retired 2026-07-05. Rewrite any sticky
// localStorage value so the browser stops requesting the dead symbol.
try {
  if (localStorage.getItem('aurexis_symbol') === 'V25_1S') {
    localStorage.setItem('aurexis_symbol', '1HZ25V');
  }
} catch { /* private mode / no storage — ignore */ }

// Preload candle data immediately on app boot — all pages get instant charts
import '@/services/candleCache';

import { ThemeProvider } from './contexts/ThemeContext';
import { ServiceHealthProvider } from './contexts/ServiceHealthContext';
import { SymbolProvider } from './contexts/SymbolContext';
import { store } from './store';

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5000,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <ServiceHealthProvider>
              <SymbolProvider>
                <App />
              </SymbolProvider>
            </ServiceHealthProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);
